import React, { useContext, useState } from "react";
import { VegaBox, VegaIcon } from "@heartlandone/vega-react";
import { PATH } from "Chore/Apis";
import { _fetch } from "Chore/Request";
import { toggleGlobalModalAction } from "Redux/Actions/actions";
import { HubContext } from "Redux/Context/context";

const { POST_FAVORITE } = PATH;

function ActivityKudo({ activityId, hasFavorited }) {
  const { globalModalDispatch } = useContext(HubContext);
  const [isFavorite, setIsFavorite] = useState(hasFavorited);
  const postKudo = (favorite) => {
    // _toggleModal(true);
    _fetch({
      api: `${POST_FAVORITE(activityId)}`,
      method: "post",
      data: {
        isFavorite: favorite,
      },
    })
      .then((res) => {
        setIsFavorite(res?.payload);
      })
      .finally(() => {
        // _toggleModal();
      });
  };

   // eslint-disable-next-line
  const _toggleModal = (isShow = false) => {
    globalModalDispatch(toggleGlobalModalAction({ isShow }));
  };

  const renderKudo = () => {
    return (
      <VegaBox
        width="32px"
        height="32px"
        corners="rounded-full"
        backgroundColor="bg-toggle-switch"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-around",
          cursor: "pointer",
        }}
        onClick={(e) => {
          e.stopPropagation();
          postKudo(true);
        }}
      >
        <VegaIcon
          icon="far fa-heart"
          color="text-sidebar-link-selected"
        ></VegaIcon>
      </VegaBox>
    );
  };

  const renderActionedKudo = () => {
    return (
      <VegaBox
        width="32px"
        height="32px"
        corners="rounded-full"
        backgroundColor="bg-primary"
        border="border-chip"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-around",
          cursor: "pointer",
        }}
        onClick={(e) => {
          e.stopPropagation();
          postKudo(false);
        }}
      >
        <VegaIcon icon="fas fa-heart" color="text-accent6-primary"></VegaIcon>
      </VegaBox>
    );
  };
  return isFavorite ? renderActionedKudo() : renderKudo();
}

export default ActivityKudo;
